import JavascriptDataType from "../../utils/stringLiterals/JavascriptDataType";

//TESTED
const stringIsNullOrEmpty = function(stringValue){
    if (valueIsUndefined(stringValue)) {

        return false;
    }
    const isValidType = (typeof stringValue === JavascriptDataType.STRING
                         || typeof stringValue === JavascriptDataType.OBJECT);
    const isNullValue = (stringValue === null);
    const isEmptyValue = (stringValue !== null && stringValue.length === 0);
    if (isValidType && (isNullValue || isEmptyValue )) {

        return true;
    }

    return false;
}

//TESTED
const objectIsNullOrEmpty = function (obj) {    
    if (obj === null || obj === undefined) {
        return true;
    }
    
    if (Array.isArray(obj)) {
        return (obj.length === 0);
    }
    
    if (typeof obj !== 'object') {
        return false;
    }

    if (obj instanceof Date) {
        return false;
    }

    const length = Object.keys(obj).length;

    return ( length === 0);
}

//TESTED
const valueIsUndefined = function(value){
    const objIsUndefinedType = (typeof value === JavascriptDataType.UNDEFINED);
    const selectedValueIsUndefined = (value === undefined);
    const isUndefined = (objIsUndefinedType && selectedValueIsUndefined);
    
    return isUndefined;
}

//TESTED
const objectIsValid = function (obj) {
    const isObjectType = (typeof obj == JavascriptDataType.OBJECT)
    const isArrayType = Array.isArray(obj);
    const isNotUndefinedType = typeof obj !== JavascriptDataType.UNDEFINED;
    const isValidObjectType = (isObjectType && !isArrayType && isNotUndefinedType);
    
    if (isValidObjectType) {

        return true;
    }

    return false;
}

//Test: DONE
const isTypeString = function (input) {
    const isType = (typeof input === JavascriptDataType.STRING);

    return isType;
}

const JsTypeInspector = Object.freeze({
    stringIsNullOrEmpty : stringIsNullOrEmpty,
    objectIsNullOrEmpty : objectIsNullOrEmpty,
    objectIsValid : objectIsValid,    
    valueIsUndefined: valueIsUndefined,
    isTypeString : isTypeString
});

export default JsTypeInspector;